import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
    productsDataView: getProductListDataView(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnTableViewGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnTableViewGridItem?: GridItemProps;
    hiddenLeftColumnStyles?: HiddenProps;
    hiddenProductListStyles?: HiddenProps;
    nosearchLeftGridStyles?: GridItemProps;
    nosearchRightGridStyles?: GridItemProps;
    spinner: LoadingSpinnerProps;
}

export const columnsStyles: ProductListColumnsStyles = {
    spinner: {
        css: css`
            margin: auto;
            display: block;
            width: 80%;
        `,
    },
    container: {
        gap: 20,
    },
    leftColumnGridItem: {
        width: [12, 12, 12, 3, 3],
    },
    leftColumnTableViewGridItem: {
        width: [12, 12, 0, 0, 0],
    },
    rightColumnGridItem: {
        width: [12, 12, 9, 9, 9],
    },
    rightColumnTableViewGridItem: {
        width: 12,
    },
    hiddenLeftColumnStyles: {
        css: css`
            width: 100%;
        `,
    },
    hiddenProductListStyles: {
        css: css`
            width: 100%;
        `,
    },
    nosearchRightGridStyles: {
        width: [12, 12, 6, 6, 6],
    },
    nosearchLeftGridStyles: {
        width: [12, 12, 6, 6, 6],
        css: css`
            margin-top: 35px;
        `,
    },
};

const styles = columnsStyles;

const ProductListColumns: FC<Props> = ({ id, view, productsDataView }) => {
    const products = productsDataView.value;
    if (!products) {
        return <LoadingSpinner {...styles.spinner} />;
    }

    const leftColumnGridItemStyle = view === "Table" ? styles.leftColumnTableViewGridItem : styles.leftColumnGridItem;
    const rightColumnGridItemStyle =
        view === "Table" ? styles.rightColumnTableViewGridItem : styles.rightColumnGridItem;

    


    return products?.length! > 0 ? (
        <GridContainer {...styles.container}>
            <GridItem {...leftColumnGridItemStyle}>
                <Hidden {...styles.hiddenLeftColumnStyles} below="lg">
                    <Zone contentId={id} zoneName="Content00" />
                </Hidden>
                <Hidden above="sm" {...styles.hiddenProductListStyles}>
                    <Zone contentId={id} zoneName="Content02" />
                </Hidden>
            </GridItem>
            <GridItem {...rightColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
        </GridContainer>
    ) : ( 
        <GridContainer>
            <GridItem {...styles.nosearchLeftGridStyles}>
                <Zone contentId={id} zoneName="Content05" />
            </GridItem>
            <GridItem {...styles.nosearchRightGridStyles}>
                <Zone contentId={id} zoneName="Content06" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListColumns),
    definition: {
        group: "Product List",
        displayName: "Columns",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
